export class Diretoria {
  public codigoDiretoria:number;
  public nomeDiretoria:string;
  public codigoTipoDiretoria:number;
  public codigoPolo?:number;
  public latitude: string;
  public longitude: string;
}
